import { useMutation } from "@apollo/client/react";
import { CREATE_MONITOR_EXCLUSION } from "../../mutations/aml/createMonitorExclusion";
import GET_ALL_MONITOR_EVENTS from "../../queries/aml/getAllMonitorEvents";
import GET_CLIENT_MONITORING_EVENTS from "../../queries/aml/getClientMointoringEvents";

export const useCreateMonitorExclusion = ({
  onCompleted,
  onError,
  skipRefetch = false,
}: {
  onCompleted: (result: any) => void;
  onError: (error: any) => void;
  skipRefetch?: boolean;
}) => {
  const [createMonitorExclusion, { data, loading, error }] = useMutation(
    CREATE_MONITOR_EXCLUSION,
    {
      onCompleted: onCompleted,
      onError: onError,
      refetchQueries: skipRefetch
        ? []
        : [GET_CLIENT_MONITORING_EVENTS, GET_ALL_MONITOR_EVENTS],
      awaitRefetchQueries: true,
    }
  );

  return { createMonitorExclusion, data, loading, error };
};
